// Shared display/grouping logic for the EvedPay mobile transaction lists
// (transactions.vue and cardtransactions.vue). Both screens render the same row
// anatomy and the same display buckets — keeping the logic here prevents the
// bucket names, colors, and sort order from drifting between the two.
export default {
  methods: {
    transactionStatusColor(status, reconcileStatus) {
      if ((status === 'In Envelope' && reconcileStatus === 'Approved') || (['Exported', 'Posted'].includes(status) && ['Coded', 'Approved'].includes(reconcileStatus))) {
        return 'alt'
      } else if (['Open', 'Returned', 'In Envelope'].includes(status) && reconcileStatus === 'Open') {
        return 'warn'
      } else if (status === 'Declined') {
        return 'danger'
      } else if (status === 'Pending' && reconcileStatus === 'Open') {
        return 'info'
      } else if (['Open', 'Returned', 'In Envelope', 'Pending'].includes(status) && reconcileStatus === 'Coded') {
        return 'alt'
      } else {
        return 'info'
      }
    },
    headerText(transaction) {
      const status = transaction.status
      const reconcileStatus = transaction.reconcileStatus

      if ((status === 'In Envelope' && reconcileStatus === 'Approved') ||
          (['Exported', 'Posted'].includes(status) && ['Coded', 'Approved'].includes(reconcileStatus)) ||
          (['Open', 'Returned', 'In Envelope', 'Pending'].includes(status) && reconcileStatus === 'Coded')) {
        return 'Completed'
      }
      if (status === 'Declined') {
        return 'Declined'
      }
      if (status === 'Pending' && reconcileStatus === 'Open') {
        return 'Pending'
      }
      if (['Open', 'Returned', 'In Envelope'].includes(status) && reconcileStatus === 'Open') {
        return 'Reconcile'
      }
      return `${status} - ${reconcileStatus}`
    },
    sortByDisplayGroup() {
      if (!Array.isArray(this.transactions)) {
        return
      }
      // The server orders by its own TransactionGroup buckets, which lump several display groups
      // together (notably Pending and Reconcile rows share the "5_Open" bucket because both have
      // ReconciliationStatus "Open"), so rows from different headerText() groups arrive interleaved
      // by date and the compare-to-previous showHeader() renders the same header repeatedly. Group
      // by the display header here so each header appears exactly once, in a fixed order.
      const order = { Reconcile: 0, Pending: 1, Completed: 2, Declined: 3 }
      const rankOf = (h) => (Object.prototype.hasOwnProperty.call(order, h) ? order[h] : 99)
      this.transactions.sort((a, b) => {
        const ha = this.headerText(a)
        const hb = this.headerText(b)
        const diff = rankOf(ha) - rankOf(hb)
        if (diff !== 0) {
          return diff
        }
        if (ha < hb) {
          return -1
        }
        if (ha > hb) {
          return 1
        }
        return 0
      })
    },
    showHeader(transaction, index) {
      if (index === 0) return true

      const previousTransaction = this.transactions[index - 1]
      return this.headerText(transaction) !== this.headerText(previousTransaction)
    },
    redirectTransaction(transaction) {
      var query = { ...this.$route.query }
      delete query.receiptScanId
      query.transactionid = transaction.id
      this.$router.push({ path: '/evedpay/transactiondetails', query: query })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/_modules/EvedPay/transactionDisplayMixin.js